import { jsx } from 'react/jsx-runtime';

const Minus = ({ className, size }) => (jsx("svg", { className: className, fill: "none", height: size, viewBox: "0 0 8 8", width: size, xmlns: "http://www.w3.org/2000/svg", children: jsx("path", { d: "M0 3H8V5H0V3Z", fill: "currentColor" }) }));

export { Minus as M };
//# sourceMappingURL=component-D__afgue.js.map
